// Products on the bill being returned that were sent for alteration (an open
// or handed-over ticket; a cancelled one doesn't count). { ids: Set, status }.
// A failed check doesn't block the return: the pieces just aren't marked.
import { useEffect, useState } from "react";
import { fashionPosService } from "../../../../services";
import { buildAlterationsQuery, readAlterations } from "../../../../utils/fashion/alterations";

const NONE = new Set();
const STATUSES = ["OPEN", "DLV"];

export function alteredIdsOf(lists, documentNo) {
  const ids = new Set();
  (lists || []).forEach((list) =>
    (list || []).forEach((a) => {
      if (a?.productId && a.status !== "CAN" && a.orderDocumentNo === documentNo) ids.add(a.productId);
    }),
  );
  return ids;
}

export default function useAlteredIds(order, tillData) {
  const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
  const documentNo = order?.documentno;
  const [state, setState] = useState({ ids: NONE, status: "done" });

  useEffect(() => {
    if (!bunitId || !documentNo) {
      setState({ ids: NONE, status: "done" });
      return undefined;
    }
    let live = true;
    setState({ ids: NONE, status: "loading" });
    Promise.all(STATUSES.map((st) => Promise.resolve(fashionPosService(buildAlterationsQuery(bunitId, st, documentNo, 50))).then(readAlterations, () => null))).then((lists) => {
      if (!live) return;
      if (lists.every((l) => l === null)) setState({ ids: NONE, status: "error" });
      else setState({ ids: alteredIdsOf(lists, documentNo), status: "done" });
    });
    return () => {
      live = false;
    };
  }, [bunitId, documentNo]);

  return state;
}
